import { get } from 'lodash';

export const getAssetsListTypes = (state) =>
    get(state, ['assetList', 'filters', 'assetTypes'], []).map((item) => item.value);
